export default __webpack_public_path__ + "static/media/logo.e35fca19.jpg";